import {
  FamilyAllotmentStateTypes,
  FamilyAllotmentActionTypes,
} from "./FamilyAllotment.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FamilyAllotmentStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FamilyAllotmentReducer = (
  state: FamilyAllotmentStateTypes = INITIAL_STATE,
  action: any
): FamilyAllotmentStateTypes => {
  switch (action.type) {
    case FamilyAllotmentActionTypes.FETCH_ALL_FAMILY_ALLOTMENT:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FamilyAllotmentActionTypes.FETCH_ALL_FAMILY_ALLOTMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FamilyAllotmentActionTypes.FETCH_ALL_FAMILY_ALLOTMENT_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FamilyAllotmentActionTypes.FETCH_ALL_FAMILY_ALLOTMENT_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FamilyAllotmentActionTypes.FETCH_ONE_FAMILY_ALLOTMENT:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FamilyAllotmentActionTypes.FETCH_ONE_FAMILY_ALLOTMENT_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FamilyAllotmentActionTypes.FETCH_ONE_FAMILY_ALLOTMENT_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FamilyAllotmentActionTypes.FETCH_ONE_FAMILY_ALLOTMENT_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FamilyAllotmentReducer;
